export default __webpack_public_path__ + "static/media/spaceship.b6737cfc.svg";